import { useEffect, useState } from 'react';

const apiBase = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787';

interface RefreshLogData {
  lastUpdated: string | null;
  recordCount: number;
}

export function TrustBar() {
  const [mounted, setMounted] = useState(false);
  const [data, setData] = useState<RefreshLogData | null>(null);

  useEffect(() => {
    setMounted(true);
    const timer = setTimeout(() => {
      fetch(`${apiBase}/api/prices/refresh-log`)
        .then((r) => r.ok ? r.json() : Promise.reject())
        .then((d: { lastUpdated: string | null; recordCount: number }) => setData(d))
        .catch(() => {});
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const formattedDate = data?.lastUpdated
    ? new Date(data.lastUpdated).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    : null;

  // Render static text only during SSR / react-snap snapshot.
  // Dynamic parts (timestamp, count) are added after client hydration
  // to prevent React hydration mismatch error #418.
  return (
    <div className="w-full px-4 py-1.5 flex items-center justify-center overflow-hidden" style={{ backgroundColor: 'var(--surface-container-high)', borderBottom: '1px solid var(--outline-variant)' }}>
      <p className="font-mono text-[10px] tracking-wide whitespace-nowrap overflow-hidden text-ellipsis text-center" style={{ color: 'var(--text-secondary)' }}>
        Prices from Azure Retail Prices API
        {mounted && formattedDate && <> · Updated: {formattedDate}</>}
        {mounted && data?.recordCount ? <> · {data.recordCount.toLocaleString()} prices cached</> : null}
        {' '}· UK South · GBP · Not affiliated with Microsoft
      </p>
    </div>
  );
}
